import React, { useState } from 'react';
import {
  Box,
  Heading,
  Button,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  HStack,
  Text,
  Switch,
} from '@chakra-ui/react';
import { formatDateTime } from '../utils/dateUtils';

const fakeMedicalOrders = [
  {
    id: 'med-001',
    status: 'SHIPPED',
    updatedAt: '2025-04-23T14:23:00Z',
    createdAt: '2025-04-21T11:12:00Z',
    physician: 'Dr. Lopez',
  },
  {
    id: 'med-002',
    status: 'PENDING',
    updatedAt: '2025-04-22T13:00:00Z',
    createdAt: '2025-04-20T10:00:00Z',
    physician: 'Dr. Chen',
  },
  {
    id: 'med-003',
    status: 'IN PROGRESS',
    updatedAt: '2025-04-21T16:45:00Z',
    createdAt: '2025-04-19T08:15:00Z',
    physician: 'Dr. Singh',
  },
];

const fakeAestheticOrders = [
  {
    id: 'aes-001',
    status: 'SHIPPED',
    updatedAt: '2025-04-24T12:00:00Z',
    createdAt: '2025-04-22T09:30:00Z',
    orderer: 'Mike Patel',
  },
  {
    id: 'aes-002',
    status: 'PENDING',
    updatedAt: '2025-04-23T15:15:00Z',
    createdAt: '2025-04-21T13:20:00Z',
    orderer: 'Sandra Kim',
  },
];

const OrderUpdatesPage = () => {
  const [isMedical, setIsMedical] = useState(true);
  const activeOrders = isMedical ? fakeMedicalOrders : fakeAestheticOrders;

  return (
      <Box p={8}>
        <HStack justify="space-between" mb={6}>
          <Heading size="lg">Order Updates</Heading>
          <HStack>
            <Text fontWeight="bold">Medical</Text>
            <Switch
              isChecked={!isMedical}
              onChange={() => setIsMedical(!isMedical)}
              colorScheme="teal"
            />
            <Text fontWeight="bold">Aesthetic</Text>
          </HStack>
        </HStack>

        <Table variant="simple" size="md">
          <Thead>
            <Tr>
              <Th>Order ID</Th>
              <Th>Status</Th>
              <Th>{isMedical ? 'Physician' : 'Orderer'}</Th>
              <Th>Updated</Th>
              <Th>Created</Th>
            </Tr>
          </Thead>
          <Tbody>
            {activeOrders.map((order) => (
              <Tr key={order.id}>
                <Td>{order.id}</Td>
                <Td>
                  <Badge
                    colorScheme={
                      order.status === 'SHIPPED'
                        ? 'green'
                        : order.status === 'IN PROGRESS'
                        ? 'yellow'
                        : 'gray'
                    }
                  >
                    {order.status}
                  </Badge>
                </Td>
                <Td>{isMedical ? order.physician : order.orderer}</Td>
                <Td>{formatDateTime(order.updatedAt)}</Td>
                <Td>{formatDateTime(order.createdAt)}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
  );
};

export default OrderUpdatesPage;